const CardStyles = {
  '.invalid': {
    color: 'red',
    'font-weight': 'unset',
  },
  '.valid': {
    color: 'black',
    'font-weight': 'unset',
  },
  ':focus': {
    color: 'black',
    'font-weight': 'unset',
  },
  input: {
    color: 'grey',
    'font-size': '14px',
    'font-weight': 'lighter',
  },
};

export default CardStyles;
